<div class="age-verification-overlay">
  <div class="age-verification-popup">
    <div class="popup-header">
      <img
        [ngSrc]="storyblokService.getImageUrl({filename: 'https://a.storyblok.com/f/106593/5459x1241/65f115b636/supervin_hvidorange_highres.png?cv=1717662140574'})"
        alt="Supervin"
        height="39"
        width="186"
      />
      <h2 class="welcome-message">Välkommen</h2>
    </div>
    <div class="popup-content">
      <p class="warning-text">
        Observera att du måste ha fyllt 20 år för att handla alkohol (vin) på Supervin.se.
      </p>
      <h2 class="question">ÄR DU ÖVER 20 ÅR?</h2>
      <div class="button-group">
        <button class="btn btn-red-dark" (click)="onNo()">Nej</button>
        <button class="btn btn-primary" (click)="onYes()">Ja</button>
      </div>
    </div>
  </div>
</div>
